<div class="image-card">    
    <img class="img-fluid w-100 img-fit h-100" [src]="imagPath" alt="Image">
    <span *ngIf="data?.api_caption || data?.text?.caption || data?.text?.fileName" 
    class="chat_area__message__text d-block mt-2">{{data?.api_caption || data?.text?.caption || data?.text?.fileName}}</span>
</div>